import { z } from 'zod'
import { productDto } from './product'
import { optionsGroupsMainSchema } from './optionGroups'
import { priceTotals, saleTypeUnion } from './common'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cartAddInput = z.object({
  sessionId: z.string(),
  coupon: z.string().optional(),
  product: productDto.extend({
    units: z.number(),
    isRedeemable: z.boolean(),
    // GTM item_list_name captured by the front when this product was added to the cart —
    // the backend persists it verbatim and echoes it back on every later cart response.
    itemListName: z.string().optional()
  })
})

export type CartAddInput = z.infer<typeof cartAddInput>

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cartModifyInput = z.object({
  sessionId: z.string(),
  productCartId: z.string(),
  units: z.number().optional(),
  optionsGroups: z.array(optionsGroupsMainSchema).optional()
})

export type CartModifyInput = z.infer<typeof cartModifyInput>

const cartProduct = productDto.extend({
  productCartId: z.string(),
  units: z.number(),
  // price of all units
  priceComputed: z.number(),
  // price unit with extras
  priceWithExtras: z.number(),
  // loyalty
  points: z.number().optional(),
  // GTM item_list_name persisted by the backend since this line was added to the cart
  itemListName: z.string().optional()
})

export type CartProduct = z.infer<typeof cartProduct>

// Dto
export const cartDto = z.object({
  totals: priceTotals,
  sessionId: z.string(),
  saleType: saleTypeUnion,
  productsTotals: z.array(cartProduct),
  coupons: z.array(z.string())
})

export type Cart = z.infer<typeof cartDto>

export const endSessionDto = z.object({
  success: z.boolean(),
  description: z.string()
})
